module.exports = __webpack_public_path__ + "static/media/Tech Resume.f449bc93.pdf";